export class TotalOption {
  insertIndex: number; // 插入下标
  insertValue: any; // 插入值
  align?: string; // 靠左还是靠右
  showDecimal?: boolean; // 是否显示小数位
  preserveNumber?: number; // 保留小数位数，不传默认 2
  isHide?: boolean; // 是否隐藏, 这里只针对列会同步消失的场景
}
